"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesUsageSummaryHeader = void 0;
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const text_field_1 = require("client/components/material/text-field");
const modal_1 = require("client/components/modal");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/reporting/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
require("./sales-usage-summary-header.less");
let SalesUsageSummaryHeader = class SalesUsageSummaryHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.filterText = "";
        this.filterDate = "";
        this.siteId = 0;
        this.startDate = "";
        this.endDate = "";
        this.distributor = "";
        this.ndcValue = "";
        this.headerToggle = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
        };
        this.handleLoader = () => {
            store_1.reportsStore.showLoader = !store_1.reportsStore.showLoader;
        };
        this.handleChangeDistributor = (value) => {
            this.distributor = value;
        };
        this.handleSubmitQuery = async () => {
            this.handleLoader();
            this.headerToggle();
            await store_1.reportsStore.loadSalesUsage(this.siteId, this.searchType, this.distributor, this.ndcValue, this.startDate, this.endDate, true);
        };
        this.handleNdcChange = (e) => {
            const inputValue = e.target.value;
            const inputLength = inputValue.length;
            if (inputLength > 11) {
                return;
            }
            this.ndcValue = inputValue;
        };
        this.handleChangeSearchType = (searchType) => {
            this.searchType = searchType;
            this.distributor = "";
            this.ndcValue = "";
        };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
        };
        // Too lazy to figure out how to determine  which is which based on e.target.
        // So just rewrote pretty much the same functions for the date picker buttons
        // but for the individual start and end dates.
        this.handleClickTodayStart = () => {
            const date = new Date().toDateString();
            this.startDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickTodayEnd = () => {
            const date = new Date().toDateString();
            this.endDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickClearStart = () => {
            this.startDate = "";
        };
        this.handleClickClearEnd = () => {
            this.endDate = "";
        };
        this.handleDatePickerChangeStart = (value) => {
            this.startDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleDatePickerChangeEnd = (value) => {
            this.endDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleCancel = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
        };
    }
    get availableSearchTypes() {
        return [
            {
                id: 1,
                label: "Search by Distributor",
                value: "distId"
            },
            {
                id: 2,
                label: "Search by NDC",
                value: "ndc"
            }
        ];
    }
    // @observable
    // public showDisabledSites: boolean = false;
    async componentDidMount() {
        await store_1.reportsStore.getDistributors();
        if (store_3.usersStore.user.value &&
            store_3.usersStore.user.value.siteUser &&
            store_3.usersStore.user.value.siteId) {
            this.siteId = store_3.usersStore.user.value.siteId;
            this.handleChangeSite(String(this.siteId));
        }
        else {
            await store_2.sitesListStore.loadSitesNoRelation();
        }
    }
    get availableOptions() {
        const options = store_1.reportsStore.distributors
            ? store_1.reportsStore.distributors.map((dist, i) => ({
                id: i,
                label: dist.label,
                value: dist.value
            }))
            : [];
        const optionAll = {
            id: -1,
            label: "All distributors",
            value: ""
        };
        options.unshift(optionAll);
        return options;
    }
    get availableSiteOptions() {
        const options = [];
        const isImbUser = store_3.usersStore.user.value.user;
        if (isImbUser) {
            if (store_2.sitesListStore.sites.value) {
                options.push({ id: 0, label: "All Pharmacies", value: "0" });
                store_2.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString()
                    });
                });
            }
        }
        else {
            const { site } = store_3.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: site.displayName || site.name,
                value: site.id.toString()
            };
            options.push(siteOption);
        }
        return options;
    }
    render() {
        const { label = "Search", title, withDatePicker } = this.props;
        const buttons = [];
        buttons.push(React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"), React.createElement(button_1.MaterialButton, { className: "btnSubmit", onClick: this.handleSubmitQuery, primary: true, style: { marginLeft: "1em" } }, "Submit"));
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                title && (React.createElement("div", { className: "filter-bar__title", style: { margin: "10px" } },
                    React.createElement("div", { className: "filter-bar__title-text" }, title))),
                React.createElement(button_1.MaterialButton, { onClick: () => this.headerToggle(), style: { margin: "10px" } }, "Query Options")),
            store_1.reportsStore.editModal ? (React.createElement(modal_1.Modal, { onCancel: this.headerToggle, height: "fit-content", top: "25%", width: "fit-content", buttons: buttons },
                React.createElement("div", { className: "filter-bar" },
                    React.createElement("div", { style: { display: "flex" } },
                        React.createElement(select_1.MaterialSelect, { options: this.availableSiteOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.siteId) || "", width: "100%" }),
                        React.createElement("br", null),
                        React.createElement(select_1.MaterialSelect, { options: this.availableSearchTypes, required: true, label: "Search Type", onSelect: this.handleChangeSearchType, value: this.searchType, width: "100%" }),
                        React.createElement("br", null),
                        this.searchType === "distId" ? (React.createElement(React.Fragment, null,
                            React.createElement("div", null, "Please select a distributor."),
                            React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, label: "Distributor", onSelect: this.handleChangeDistributor, value: String(this.distributor), width: "100%" }),
                            React.createElement("br", null))) : null,
                        this.searchType === "ndc" ? (React.createElement(React.Fragment, null,
                            React.createElement("div", null, "Please insert 11 digits, without spaces and without dashes (Defaults to all NDCs)."),
                            React.createElement(text_field_1.MaterialTextField, { className: "product-search-field", label: "NDC", 
                                // required
                                value: this.ndcValue, onChange: e => this.handleNdcChange(e) }))) : null),
                    React.createElement("div", { style: { display: "flex" } },
                        withDatePicker && (React.createElement("div", { className: "filter-bar", style: { paddingRight: "1em" } },
                            React.createElement("h3", null, "Start Date: "),
                            React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "Start Date", required: true, value: this.startDate || "", onChange: this.handleDatePickerChangeStart }),
                            React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayStart, style: { marginRight: "1em" } }, "Today"),
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearStart }, "Clear")))),
                        withDatePicker && (React.createElement("div", { className: "filter-bar" },
                            React.createElement("h3", null, "End Date: "),
                            React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "End Date", required: true, value: this.endDate || "", onChange: this.handleDatePickerChangeEnd }),
                            React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayEnd, style: { marginRight: "1em" } }, "Today"),
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearEnd }, "Clear")))))))) : null,
            store_1.reportsStore.showLoader ? React.createElement(ui_1.UiLoadingIndicator, null) : null));
    }
};
__decorate([
    mobx_1.computed
], SalesUsageSummaryHeader.prototype, "availableSearchTypes", null);
__decorate([
    mobx_1.observable
], SalesUsageSummaryHeader.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], SalesUsageSummaryHeader.prototype, "filterDate", void 0);
__decorate([
    mobx_1.observable
], SalesUsageSummaryHeader.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], SalesUsageSummaryHeader.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], SalesUsageSummaryHeader.prototype, "endDate", void 0);
__decorate([
    mobx_1.observable
], SalesUsageSummaryHeader.prototype, "distributor", void 0);
__decorate([
    mobx_1.observable
], SalesUsageSummaryHeader.prototype, "ndcValue", void 0);
__decorate([
    mobx_1.observable
], SalesUsageSummaryHeader.prototype, "searchType", void 0);
__decorate([
    mobx_1.computed
], SalesUsageSummaryHeader.prototype, "availableOptions", null);
__decorate([
    mobx_1.computed
], SalesUsageSummaryHeader.prototype, "availableSiteOptions", null);
SalesUsageSummaryHeader = __decorate([
    mobx_react_1.observer
], SalesUsageSummaryHeader);
exports.SalesUsageSummaryHeader = SalesUsageSummaryHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/sales-usage-summary/components/sales-usage-summary-header/sales-usage-summary-header.tsx
// module id = 3955
// module chunks = 0